import { Menu } from "@/types/menu";

export function parseMenu(
  text: string | undefined | null,
  restaurantId: string,
  detectedLanguage: string
): Menu {
  // Ensure language is lowercase for consistency
  const normalizedLanguage = detectedLanguage.toLowerCase();

  if (!text || typeof text !== "string") {
    return createEmptyMenu(restaurantId, normalizedLanguage);
  }

  // Clean up text from PDF/OCR artifacts
  const cleanedText = text
    .replace(/\s+/g, " ")  // Replace multiple spaces with single space
    .replace(/[^\S\r\n]+/g, " ")  // Replace multiple spaces (but keep newlines)
    .trim();

  // Simple menu structure with just the original text
  return {
    id: `menu-${Date.now()}`,
    restaurantId,
    title: {
      [normalizedLanguage]: "Menu"
    },
    categories: [
      {
        id: "all-items",
        name: {
          [normalizedLanguage]: "Menu"
        },
        items: [
          {
            id: "text-content",
            name: {
              [normalizedLanguage]: cleanedText
            },
            description: {
              [normalizedLanguage]: ""
            },
            price: {
              amount: 0,
              taxIncluded: undefined
            },
            category: "all-items",
          },
        ],
      },
    ],
    lastUpdated: new Date().toISOString(),
    status: "completed",
    supportedLanguages: [normalizedLanguage],
  };
}

function createEmptyMenu(restaurantId: string, detectedLanguage: string): Menu {
  // Ensure language is lowercase for consistency
  const normalizedLanguage = detectedLanguage.toLowerCase();
  
  return {
    id: `menu-${Date.now()}`,
    restaurantId,
    title: {
      [normalizedLanguage]: "Menu"
    },
    categories: [],
    lastUpdated: new Date().toISOString(),
    status: "failed",
    supportedLanguages: [normalizedLanguage],
  };
}

export function formatPrice(
  price: { amount?: number; taxIncluded?: number } | undefined,
  currency: string = "¥"
): string {
  if (!price?.amount || typeof price.amount !== "number") {
    return `${currency}0`;
  }

  const formattedAmount = `${currency}${price.amount.toLocaleString("ja-JP")}`;
  if (price.taxIncluded && price.taxIncluded !== price.amount) {
    return `${formattedAmount} (税込 ${currency}${price.taxIncluded.toLocaleString(
      "ja-JP"
    )})`;
  }

  return formattedAmount;
}
